import React, { ReactFragment } from "react"
import { ReactChild } from "react"
import styled from "styled-components"

interface Props {
  className?: string
  children?: ReactChild | ReactChild[]
}

const Inner = styled.div`
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
`

export default function ContentInner(props: Props) {
  const { children, className } = props

  return <Inner className={className}>{children}</Inner>
}
